import { api, unwrap, toPaginated } from "../lib/axios";
import type { ApiEnvelope, PaginatedResult } from "../types/api";
import type { TollLocation } from "../types/domain";

export const tollLocationsApi = {
  async list(
    params: { isActive?: boolean } = {},
  ): Promise<PaginatedResult<TollLocation>> {
    const res = await api.get<ApiEnvelope<unknown>>("/toll-location", {
      params,
    });
    return toPaginated<TollLocation>(res, "tollLocations");
  },

  async get(id: string): Promise<TollLocation> {
    const res = await api.get<ApiEnvelope<TollLocation>>(
      `/toll-location/${id}`,
    );
    return unwrap(res);
  },

  async create(body: Partial<TollLocation>): Promise<TollLocation> {
    const res = await api.post<ApiEnvelope<TollLocation>>(
      "/toll-location",
      body,
    );
    return unwrap(res);
  },

  async update(
    id: string,
    body: Partial<TollLocation>,
  ): Promise<TollLocation> {
    const res = await api.patch<ApiEnvelope<TollLocation>>(
      `/toll-location/${id}`,
      body,
    );
    return unwrap(res);
  },

  async remove(id: string): Promise<void> {
    await api.delete(`/toll-location/${id}`);
  },
};
